import Module from "./apps/SmartControlModule.svelte";
import { mount } from "svelte";
window.SmartControlModule = function (options) {
    return mount(Module, options);
};
